import React from 'react';
import { Navigate } from 'react-router-dom';

function HomeView() {
    return <Navigate to="/admissions-advisor" replace />
}

export default HomeView;